import {AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TabService} from '../tab.service';

@Component({
  selector: 'spb-single-tab',
  templateUrl: './tab.component.html',
})
export class TabComponent implements OnInit, OnChanges, AfterViewInit {


  shouldShow: boolean;
  @Input() tabKey: string;

  constructor(private tabService: TabService,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.shouldShow = false;
    if (this.tabService.getTabChangeEventSubject()) {
      this.tabService.getTabChangeEventSubject()
          .subscribe(tab => {
            this.shouldShow = this.tabKey === tab.key;
            this.cdRef.detectChanges();
          });
    }
  }

  ngAfterViewInit(): void {
  }


  ngOnChanges(changes: SimpleChanges): void {
  }

}